import { Component, OnInit, AfterViewInit } from "@angular/core";
import {
  AuthService,
  UserService,
  FacilityService,
  MessageService,
} from "src/app/services";
import { Router } from "@angular/router";
import { User } from "oidc-client";
import { UserIdleService } from "angular-user-idle";
import { Security, UserDetail, UserFacility } from "src/app/models";
import { forkJoin } from "rxjs";
@Component({
  selector: "bart-auth-call-back",
  templateUrl: "./auth-call-back.component.html",
  styleUrls: ["./auth-call-back.component.scss"],
})
export class AuthCallBackComponent implements OnInit {
  currentUser: User;
  objuserinfo: UserDetail = new UserDetail();
  constructor(
    private authService: AuthService,
    private _router: Router,
    private userIdle: UserIdleService,
    private userService: UserService,
    private facilityService: FacilityService,
    private messageService: MessageService
  ) {}
  ngOnInit() {
    setTimeout(() => {
      localStorage.removeItem("getUserFacilities");
      localStorage.removeItem("userFacilityIdList");
      localStorage.removeItem("getUserLocations");
      localStorage.removeItem("userInfo");
      console.log("completeAuthentication 1");
      this.authService.completeAuthentication().then((obj) => {
        this.authService.getUser().then((objUser) => {
          try {
            this.currentUser = objUser;
            this.objuserinfo.bartRoleCode = this.getBartRoleCodeFromOIMRoleCode(
              this.currentUser.profile.PriviledgeIDList.toUpperCase()
            );
            this.objuserinfo.userName = this.currentUser.profile.sub;
            this.objuserinfo.userId = Number(
              this.currentUser.profile.UserNumber
            );
            this.objuserinfo.firstLastName =
              this.currentUser.profile.FirstLastName;
            this.objuserinfo.emailAddress =
              this.currentUser.profile.EmailAddress;
            this.objuserinfo.assignedFacilityNumbers = Array.isArray(
              this.currentUser.profile.UserRoleLocation
            )
              ? this.currentUser.profile.UserRoleLocation.map(
                  (x) => x.locationNumber
                ).join(",")
              : this.currentUser.profile.UserRoleLocation.locationNumber;
            this.userIdle.startWatching();
            // Start watching when user idle is starting.
            this.userIdle.onTimerStart().subscribe((count) => {});
            // Start watch when time is up.
            let isSessionExpired = false;
            this.userIdle.onTimeout().subscribe(() => {
              if (isSessionExpired == false) {
                this.authService.signOut();
                isSessionExpired = true;
              }
            });
            this.loadAuthPreveledge(() => {
              let encryptUserInfo = Security.encrypt(
                JSON.stringify(this.objuserinfo)
              );
              this.userService.setCurrentUserDetails(encryptUserInfo); //Set Local Storage
              let currentURL = decodeURIComponent(
                this.authService.getFromLocal("currenturl")
              );
              let currentURLArray = currentURL.split("?");
              let componentNameArray = currentURLArray[0].split("/");
              if (
                componentNameArray.length > 2 &&
                componentNameArray[3].length > 0
              ) {
                this._router.navigate([
                  componentNameArray[componentNameArray.length - 1],
                ]);
              } else {
                // FREQ-685094 Default page upon successful login
                if (
                  this.objuserinfo.bartRoleCode == "FA" ||
                  this.objuserinfo.bartRoleCode == "LCU" ||
                  this.objuserinfo.bartRoleCode == "UCU"
                ) {
                  this._router.navigate(["/WaterLab"]);
                } else if (this.objuserinfo.bartRoleCode == "HHD") {
                  this._router.navigate(["/reports"]);
                } else {
                  this._router.navigate(["/dashboard"]);
                }
              }
              //this.loadUserFacility(this.objuserinfo.userName, null);
              this.loadUserLocation(this.objuserinfo.userName);
            });
          } catch (ex) {
            this.messageService.setErrorPageMessage("403:Access Denied");
            this._router.navigate(["/error"]);
            console.log(ex);
          }
        });
      });
    }, 0);
  }
  public loadAuthPreveledge(authCallBack) {
    let BARTPRIVS = {
      bartRoleCode: this.objuserinfo.bartRoleCode,
    };
    var request = JSON.stringify({ BARTPRIVS });
    const authPrevUrl = this.authService.getbartPrivs(request);
    const userHostInfoUrl = this.userService.getUserHostInfo();
    forkJoin([authPrevUrl, userHostInfoUrl]).subscribe(
      (response: any) => {
        let objAuthPrev: any = null;
        let objUserHostInfo = null;
        if (response) {
          objAuthPrev = response[0].length ? response[0] : null;
          objUserHostInfo = response[1] ? response[1] : null;
        }

        if (objAuthPrev != null && objAuthPrev.length > 0) {
          this.objuserinfo.bartRoleId = objAuthPrev[0].bartRoleId;
          this.objuserinfo.bartRoleDescription =
            objAuthPrev[0].bartRoleDescription;
          //#region Start:Added User Host Info Details 27-July-2023
          if (objUserHostInfo) {
            this.objuserinfo.userHostAddress = objUserHostInfo.userHostAddress;
            this.objuserinfo.remotePort = objUserHostInfo.remotePort;
            this.objuserinfo.remoteHost = objUserHostInfo.remoteHost;
            this.objuserinfo.serverIP = objUserHostInfo.serverIP;
          }
          //#endregion End:Added User Host Info Details 27-July-2023
          authCallBack();
        } else {
          this.messageService.setErrorPageMessage("403:Access Denied");
          this._router.navigate(["/error"]);
        }
      },
      (error) => {
        console.log(error);
        this.messageService.setErrorPageMessage("403:Access Denied");
        this._router.navigate(["/error"]);

      }
    );
  }
  public getBartRoleCodeFromOIMRoleCode(tempbartRoleCode: string) {
    let arrPriviledgeIDList = tempbartRoleCode.split(",");
    if (arrPriviledgeIDList.indexOf("BART_ADMIN") != -1) {
      return "ADMIN";
    } else if (arrPriviledgeIDList.indexOf("BART_ABS_SYX") != -1) {
      return "BOMX";
    } else if (arrPriviledgeIDList.indexOf("BART_DBM") != -1) {
      return "BOM";
    } else if (arrPriviledgeIDList.indexOf("BART_ANALYST") != -1) {
      return "ANALYST";
    } else if (arrPriviledgeIDList.indexOf("BART_BIOMED_SYX") != -1) {
      return "BSSX";
    } else if (arrPriviledgeIDList.indexOf("BART_BMT") != -1) {
      return "BSS";
    } else if (arrPriviledgeIDList.indexOf("BART_HHD") != -1) {
      return "HHD";
    } else if (
      arrPriviledgeIDList.indexOf("BART_CLINICAL_SUPERVISOR_SYX") != -1
    ) {
      return "CLNSX";
    } else if (arrPriviledgeIDList.indexOf("BART_CLINICAL_SYX") != -1) {
      return "CLNX";
    } else if (
      arrPriviledgeIDList.indexOf("BART_CLINICAL_SUPERVISOR_NURSE_SYX") != -1
    ) {
      return "CLNLNX";
    } else if (arrPriviledgeIDList.indexOf("BART_NURSE_SYX") != -1) {
      return "LNX";
    } else if (arrPriviledgeIDList.indexOf("BART_FIELD_ADMINISTRATOR") != -1) {
      return "FA";
    } else if (
      arrPriviledgeIDList.indexOf("BART_LICENSED_CLINICAL_USER") != -1
    ) {
      return "LCU";
    } else if (
      arrPriviledgeIDList.indexOf("BART_UNLICENSED_CLINICAL_USER") != -1
    ) {
      return "UCU";
    } else {
      return "";
    }
  }

  public loadUserLocation(userName: string) {
    var getLocationParam = {
      GETUSERLOCATIONS: {
        LOCATION_ID_LIST: "",
        USERNAME: userName,
      },
      GETUSERLOCATIONS2: {
        USERNAME: userName,
      },
    };
    this.facilityService
      .getUserLocations(JSON.stringify(getLocationParam))
      .subscribe((data) => {});
  }
}
